import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AixAlertDialog } from "@aix/ui"
import MaxWidthWrapper from "@aix/ui/src/custom/MaxWidthWrapper"
import { useState } from "react"
import Description from "~/components/Marketing/Description"
import FreeTools from "~/components/Marketing/FreeTools"
import Title from "~/components/Marketing/Title"
import { useAuthSession } from "~/hooks/useAuthSession"
import MarketingLayout from "~/layouts/MarketingLayout"
import type { FreeTool } from "~/utils/tools"
import { TOOLS } from "~/utils/tools"

import type { ReactElement } from "react"

function ToolPage() {
  const { id } = Route.useParams()
  const toolIndex = TOOLS.findIndex((tool) => tool.id === id)
  const index = toolIndex !== -1 ? toolIndex : 0
  const tool = TOOLS[index]
  const Component = tool.Component

  const navigate = useNavigate()
  const { session } = useAuthSession()
  const [showRateLimit, setShowRateLimit] = useState(false)

  return (
    <div className="mb-10 mt-12 flex flex-col items-center justify-center gap-4">
      <MaxWidthWrapper className="flex flex-col items-center text-center">
        <div className="flex flex-col items-center gap-2 pb-10">
          <Title data-testid="hero-text" className="sm:text-4xl">
            {tool.title}
          </Title>

          <Description>{tool.description}</Description>
        </div>

        {Component ? <>{Component({ onError: () => setShowRateLimit(true) })}</> : null}
      </MaxWidthWrapper>

      <MaxWidthWrapper>
        <FreeTools currentTool={tool} title="Other Tools" />
      </MaxWidthWrapper>

      <AixAlertDialog
        title="Exceeding Free Tool Capacity"
        description="Our free tools are under high usage currently, please log in to get priority access."
        cancelLabel="Close"
        actionLabel={session ? "Dashboard" : "Sign Up or Sign In"}
        onActionClick={() => navigate({ to: session ? "/home" : "/auth/signin" })}
        open={showRateLimit}
        onOpenChange={setShowRateLimit}
      />
    </div>
  )
}

function ToolPageWrapper() {
  return (
    <MarketingLayout>
      <ToolPage />
    </MarketingLayout>
  )
}

export const Route = createFileRoute("/tools/$id")({
  component: ToolPageWrapper,
})
